import { BadPressMatchResolution } from '../../entities/monitoring/actual/badpress-match.model';
import { PEPMatchResolution } from './../../entities/monitoring/actual/pep-match.model';
import { SanctionMatchResolution } from './../../entities/monitoring/actual/sanction-matches.model';
/**
 * Model to emit search result details to the parent components.
 */
export class GenericSearchDetails {
    id: number;
    clientId: number;
    entityId: number;
    clientName: string;
    clientType: string;
    clientGender: string;
    clientLogo: string;
    entityType: string;
    sanctionStatus = SanctionMatchResolution.FALSE;
    pepStatus = PEPMatchResolution.FALSE;
    badPressStatus = BadPressMatchResolution.FALSE;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/generic-search-details.model.ts